import { ALBUM_MIN_DECADES, CATEGORIES, CATEGORY_META, type Category, type Decade, type Mode } from '@banger/shared';

/** Explains why a category is off, e.g. when the chosen decades rule it out. */
export function lobbyNote(active: Category[], decades: Decade[]): string | null {
  const off = CATEGORIES.filter((c) => !active.includes(c));
  if (off.length === 0) return null;
  const parts = off.map((c) => {
    if (c === 'before2000') {
      if (decades.every((d) => d < 2000)) {
        return `${CATEGORY_META[c].label} is off: all your decades are before 2000`;
      }
      return `${CATEGORY_META[c].label} is off: your decades don't straddle 2000 or 2010.`;
    }
    if (c === 'decade') return `${CATEGORY_META[c].label} is off: pick at least 2 decades`;
    return `${CATEGORY_META[c].label} is off`;
  });
  return parts.join('. ');
}

export const ALBUM_DECADES_NOTE = 'Album needs at least 3 decades — turn on more decades or switch to Single.';

/** Album's lobby guard: the note to show (and Start stays disabled) when too few decades are on. */
export function albumNote(mode: Mode, decades: readonly Decade[]): string | null {
  return mode === 'album' && decades.length < ALBUM_MIN_DECADES
    ? ALBUM_DECADES_NOTE
    : null;
}
